import { z } from "zod/v4";

import type { AWS } from "@serverless/typescript";

import { ApiScopesType } from "../dtos/apis";

import { IntelligemsAuthScopes } from "./intelligems";

export type LambdaFunction = NonNullable<AWS["functions"]>[string];

// @ts-ignore
export type AwsResource = NonNullable<AWS["resources"]["Resources"]>[string];

const baseConfigHistoryDso = z.object({
  action: z.enum(["add", "update", "delete"]),
  entity: z.string(),
  entityId: z.string(),
  entityName: z.string(),
  parentEntityId: z.string(),
  editedKey: z.string(),
  from: z.string(),
  to: z.string(),
});

export type ConfigHistoryChangeLogDto = z.infer<typeof baseConfigHistoryDso> & {
  edits: ConfigHistoryChangeLogDto[];
};

export const ConfigHistoryChangeLogDso: z.ZodType<ConfigHistoryChangeLogDto> =
  baseConfigHistoryDso.extend({
    edits: z.lazy(() => ConfigHistoryChangeLogDso.array()),
  });

export const ConfigEventDso = z.object({
  key: z.string(),
  ts: z.number(),
});

export type ConfigEventDto = z.infer<typeof ConfigEventDso>;

export interface JwtPayload {
  id?: string;
  email: string;
  firstName: string;
  lastName: string;
  orgId: string;
  exp: number;
  shopId: string;
  scope: IntelligemsAuthScopes;
  apiScopes?: ApiScopesType[];
  iat?: number;
}
